<template>
  <div class="flex flex-col sm:flex-row gap-4 items-start sm:items-center">
    <div class="flex-1">
      <ReportsPeriodSelector
        :periods="periods"
        :selected-period="selectedPeriod"
        :custom-start-date="customStartDate"
        :custom-end-date="customEndDate"
        @period-change="$emit('period-change', $event)"
        @update:custom-start-date="$emit('update:custom-start-date', $event)"
        @update:custom-end-date="$emit('update:custom-end-date', $event)"
        @apply="$emit('apply')"
      />
    </div>
    
    <div class="flex items-center gap-2">
      <ViewModeToggle
        :view-mode="viewMode === 'cards' ? 'card' : 'list'"
        @update:view-mode="(mode) => $emit('update:view-mode', mode === 'card' ? 'cards' : 'list')"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import ReportsPeriodSelector from '@/components/reports/ReportsPeriodSelector.vue'
import ViewModeToggle from '@/components/common/ViewModeToggle.vue'

interface Period {
  value: string
  label: string
}

interface Props {
  periods: Period[]
  selectedPeriod: string
  customStartDate: string
  customEndDate: string
  viewMode: 'cards' | 'list'
}

defineProps<Props>()

defineEmits<{
  'period-change': [period: string]
  'update:custom-start-date': [date: string]
  'update:custom-end-date': [date: string]
  'apply': []
  'update:view-mode': [mode: 'cards' | 'list']
}>()
</script>
